import { Checkbox, Collapse, FormControlLabel, Grid, TextField } from '@material-ui/core'
import { withStyles } from '@material-ui/styles'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect, useDispatch } from 'react-redux'
import { acGetCustomerPlanTable, acGenerateSubscription } from '../../class/actions'
import { Alert, Loader, SelectField } from '../default'
import FormPayment from './FormPayment'

const FormSubscription = ({ classes, currentCustomer, customerPlanTable, loadingCurrentTable, currentTableError, cancel }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [enableMaxPayments, setEnableMaxPayments] = useState(false)
  const [maxPayments, setMaxPayments] = useState(12)
  const [errorMaxPayments, setErrorMaxPayments] = useState(null)

  const [selectedPlan, setSelectedPlan] = useState('')
  const [plans, setPlans] = useState([])
  const [plansPrices, setPlansPrices] = useState(null)
  const [overrideAmount, setOverrideAmount] = useState(null)

  useEffect(() => {
    dispatch(acGetCustomerPlanTable(currentCustomer.id))
  }, [dispatch, currentCustomer])

  useEffect(() => {
    if (customerPlanTable && customerPlanTable.plans) {
      setPlans(customerPlanTable.plans.map(plan => ({
        name: plan.name,
        value: plan.plan_id
      })))
      setPlansPrices(Object.fromEntries(customerPlanTable.plans.map(plan => ([plan.plan_id, plan.PlanPrices.price]))))
    }
  }, [customerPlanTable])

  const validateMaxPayments = value => {
    setMaxPayments(value)
    if (isNaN(value)) {
      setErrorMaxPayments(t('forms.financial.subscription.invalidMaxPayments'))
      return
    }

    setErrorMaxPayments(null)
  }

  const onPlanChange = value => {
    setSelectedPlan(value)
    if (plansPrices[value]) {
      setOverrideAmount(plansPrices[value])
    }
  }

  const generateSubscription = data => {
    dispatch(acGenerateSubscription(currentCustomer.id, data.amount, data.paymentMethod, maxPayments, selectedPlan))
  }

  return (
    <div>
      {
        loadingCurrentTable ? <Loader /> :
          currentTableError ? <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={currentTableError.description ? currentTableError.description : t('forms.financial.subscription.unknownFetchError')} /> : (
            <Grid container spacing={2} className={classes.grid}>
              <Grid item xs={8}>
                <SelectField
                  label={t('forms.financial.plan')}
                  id='financial-subscription-plan-select'
                  value={selectedPlan}
                  onChange={(e) => onPlanChange(e.target.value)}
                  items={plans}
                  style={{ width: '100%' }} />
              </Grid>
              <Grid item xs={12}>
                <FormPayment actionOverride={generateSubscription} overrideAmount={overrideAmount} cancel={cancel}>
                  <FormControlLabel
                    label={t('forms.financial.subscription.enableMaxPayments')}
                    control={
                      <Checkbox
                        value={enableMaxPayments}
                        onChange={e => setEnableMaxPayments(e.target.checked)} />
                    }
                  />
                  <Collapse in={enableMaxPayments}>
                    <TextField
                      disabled={!enableMaxPayments}
                      variant='filled'
                      type="number"
                      label={t('forms.financial.subscription.maxPayments')}
                      value={maxPayments}
                      onChange={(e) => validateMaxPayments(e.target.value)}
                      error={errorMaxPayments ? true : false}
                      helperText={errorMaxPayments ? errorMaxPayments : null}
                      style={{ width: '100%' }} />
                  </Collapse>
                </FormPayment >
              </Grid>
            </Grid>
          )
      }
    </div>
  )
}

const styles = theme => ({
  grid: {
    display: 'flex',
    flex: 1
  },
})

const mapStateToProps = ({ ReducerPlanTable }) => ({
  customerPlanTable: ReducerPlanTable.currentTable,
  currentTableError: ReducerPlanTable.currentTableError,
  loadingCurrentTable: ReducerPlanTable.loadingCurrentTable,
})

export default connect(mapStateToProps)(withStyles(styles)(FormSubscription))